export function OrientationIcon({ active }: any) {
  const color: string = active ? "#006AB3" : "#000000";
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.9791 1.841C13.1883 2.94561 14.728 5.30209 14.9958 8.10042H16C15.5983 3.53473 12.1841 0 7.96653 0H7.49791L10.0418 2.79833L10.9791 1.841ZM6.76151 1.25188C6.35983 0.810042 5.75732 0.810042 5.35565 1.25188L1.07113 5.96485C0.669456 6.4067 0.669456 7.06946 1.07113 7.5113L9.1046 16.3481C9.50628 16.79 10.1088 16.79 10.5105 16.3481L14.795 11.6351C15.1967 11.1933 15.1967 10.5305 14.795 10.0887L6.76151 1.25188ZM9.841 15.6117L1.80753 6.7749L6.09205 2.06192L14.1255 10.8987L9.841 15.6117ZM4.95397 15.8326C2.74477 14.728 1.20502 12.3715 0.937238 9.57322H0C0.334728 14.1389 3.74895 17.6736 7.96653 17.6736H8.43515L5.89121 14.8753L4.95397 15.8326Z"
        fill={color}
      />
    </svg>
  );
}
